import {
  AKAMAI_COUNTRY_COOKIE,
  LAUNCH_OPTIN,
  LAUNCH_OPTIN_STATUS_VAR,
  LAUNCH_OPTOUT,
  ONETRUST_ADVERTISING_GROUP_OPTED_IN,
  ONETRUST_CONSENT_COOKIE,
} from './constants';

export type LaunchConsent = typeof LAUNCH_OPTIN | typeof LAUNCH_OPTOUT | 'unavailable';

function readCookie(name: string): string | null {
  try {
    if (typeof document === 'undefined' || typeof document.cookie !== 'string') return null;
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
}

export function getLaunchConsent(): LaunchConsent {
  try {
    if (typeof window === 'undefined') return 'unavailable';
    const satellite = (window as { _satellite?: { getVar?: (name: string) => unknown } })._satellite;
    const status = satellite?.getVar?.(LAUNCH_OPTIN_STATUS_VAR);
    if (status === LAUNCH_OPTIN) return LAUNCH_OPTIN;
    if (status === LAUNCH_OPTOUT) return LAUNCH_OPTOUT;
    return 'unavailable';
  } catch {
    return 'unavailable';
  }
}

// true/false when the cookie is present; null when absent/unreadable (caller falls through).
export function getOneTrustAdvertisingConsent(): boolean | null {
  const cookie = readCookie(ONETRUST_CONSENT_COOKIE);
  if (!cookie) return null;
  try {
    const groups = new URLSearchParams(cookie).get('groups');
    if (!groups) return null;
    return groups.split(',').some(entry => entry.trim() === ONETRUST_ADVERTISING_GROUP_OPTED_IN);
  } catch {
    return null;
  }
}

export function getCountryCode(): string | null {
  const raw = readCookie(AKAMAI_COUNTRY_COOKIE);
  if (!raw) return null;
  const trimmed = raw.trim().toUpperCase();
  return trimmed.length > 0 ? trimmed : null;
}
